const mktComponents = {
    componentList: [],
    loadingComponents: true
};

export default mktComponents;
